import { supabaseSyncProvider } from '@platform/cloud/supabaseProvider';

export type { RemoteDevice } from '@platform/cloud/supabaseProvider';

export function supabaseCloudStatus() {
  return supabaseSyncProvider.getStatus();
}

export function claimSupabaseBusiness(businessId: string): Promise<void> {
  return supabaseSyncProvider.claimBusiness(businessId);
}

export function registerSupabaseDevice(input: {
  readonly businessId: string;
  readonly deviceId: string;
  readonly label: string;
  readonly platform: string;
}): Promise<void> {
  return supabaseSyncProvider.registerDevice(input);
}

export function listSupabaseDevices(businessId: string) {
  return supabaseSyncProvider.listDevices(businessId);
}

export function revokeSupabaseDevice(businessId: string, deviceId: string): Promise<void> {
  return supabaseSyncProvider.revokeDevice(businessId, deviceId);
}
